module.exports = __webpack_public_path__ + "img/kcfw.78227e42.png";